import React from 'react';

const ValeursFoncieres = () => {
    return (
        <div className={'card bg-dark'}>
            <div className="card-header">
                <div className="card-title">Valeurs Foncières</div>
            </div>
            <div className="card-body">

            </div>
        </div>
    );
};

export default ValeursFoncieres;
